import { useFormikContext, useField } from "formik";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const ApprovalGroup = ({ fieldName }) => {
  const { setFieldValue } = useFormikContext();

  const [field, meta] = useField(fieldName);

  function handleChange(event, newValue) {
    if (newValue !== null) {
      setFieldValue(fieldName, newValue);
    }
  }

  const configObject = {
    size: "small",
    exclusive: true,
    value: field.value,
    onChange: handleChange,
  };

  return (
    <>
      <ToggleButtonGroup {...configObject}>
        <ToggleButton value={false}>
          <CloseRoundedIcon sx={{ color: "red" }} />
        </ToggleButton>
        <ToggleButton color="success" value={true}>
          <CheckRoundedIcon color="success" />
        </ToggleButton>
      </ToggleButtonGroup>

      {meta && meta.touched && meta.error && (
        <p style={{ color: "red" }}>Please select an option</p>
      )}
    </>
  );
};

export default ApprovalGroup;
